
import React from 'react';
import { Users, Clock } from 'lucide-react';

interface TeamBasicStatsProps {
  members: number;
  lastActivity: string;
}

const TeamBasicStats = ({ members, lastActivity }: TeamBasicStatsProps) => {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm mb-4">
      <div className="flex items-center">
        <Users className="h-4 w-4 mr-2 text-gray-400" />
        <span className="text-gray-300">{members || 0} members</span>
      </div>
      <div className="flex items-center">
        <Clock className="h-4 w-4 mr-2 text-gray-400" />
        <span className="text-gray-300">{lastActivity || 'N/A'}</span>
      </div>
    </div>
  );
};

export default TeamBasicStats;
